import { useCallback, useMemo, useState } from 'react'
import { Status } from 'state/interfaces'

export const useStatus = () => {
  const [status, setStatus] = useState<Status>(Status.INITIAL)
  const setPending = useCallback(() => {
    if (status !== Status.PENDING) {
      setStatus(Status.PENDING)
    }
  }, [status])

  const setSuccess = useCallback(() => {
    if (status !== Status.SUCCESS) {
      setStatus(Status.SUCCESS)
    }
  }, [status])

  const setError = useCallback(() => {
    if (status !== Status.ERROR) {
      setStatus(Status.ERROR)
    }
  }, [status])

  const isPending = useMemo(() => {
    return status === Status.PENDING
  }, [status])

  const isError = useMemo(() => {
    return status === Status.ERROR
  }, [status])

  const isSuccess = useMemo(() => {
    return status === Status.SUCCESS
  }, [status])

  const isInitial = useMemo(() => {
    return status === Status.INITIAL
  }, [status])

  return { current: status, setPending, setSuccess, setError, isPending, isSuccess, isError, isInitial }
}
